import type { DtsOutboundConnectorDto } from '@dhl/mdp-api'
import { DataWrapper } from '~/modules/ppp/submodules/relations/components/data'
import { OutboundKafka } from '~/modules/ppp/submodules/relations/components/outbound/OutboundKafka'
import { OutboundApi } from '~/modules/ppp/submodules/relations/components/outbound/OutboundApi'
import { OutboundSftp } from '~/modules/ppp/submodules/relations/components/outbound/OutboundSftp'
import { OutboundAggregator } from '~/modules/ppp/submodules/relations/components/outbound/OutboundAggregator'

type Props = {
  connector: DtsOutboundConnectorDto
}
export const OutboundConnector = ({ connector }: Props) => (
  <DataWrapper>
    {connector.API && <OutboundApi config={connector.API} />}
    {connector.SFTP && <OutboundSftp config={connector.SFTP} />}
    {connector.Kafka && <OutboundKafka config={connector.Kafka} />}
    {connector.Aggregator && <OutboundAggregator config={connector.Aggregator} />}
  </DataWrapper>
)
